import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { Helmet } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import Header from '../../components/Header';
import InsideHeader from '../../components/InsideHeader';
import Footer from '../../components/Footer';

const styles = css``;

function ThankYou({ page }) {
  return (
    <div className={styles}>
      <Helmet>
        <title>Thank You | Contact Us</title>
      </Helmet>
      <Header />
      <InsideHeader
        h1="Thank You"
        background={get(page, 'page_image.contentUrl')}
      />
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto py-5 text-center">
            <p>
              We have recieved your message and will respond as soon as possible.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

ThankYou.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'contact_us',
})(ThankYou);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/ThankYou.js